import { plural } from '@cian/utils';

import { TIndexableVillageObjectCount } from './index';
import { NEW_OBJECTS_KEYS, NEW_OBJECT_VARIANTS } from '../../interfaces/village';
import { IVillageCounterSetSchema } from '../../types';

export const getObjectsOnSale = ({
  onSaleCottage = 0,
  onSaleTownhouse = 0,
  onSaleLowrisehouse = 0,
  onSaleLandplot = 0,
  onSaleHouseShare = 0,
}: IVillageCounterSetSchema) => ({
  [NEW_OBJECTS_KEYS.COTTAGE]: onSaleCottage,
  [NEW_OBJECTS_KEYS.TOWNHOUSE]: onSaleTownhouse,
  [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: onSaleLowrisehouse,
  [NEW_OBJECTS_KEYS.LANDPLOT]: onSaleLandplot,
  [NEW_OBJECTS_KEYS.HOUSESHARE]: onSaleHouseShare,
});

export const generateLinkText = (objectsOnSale: TIndexableVillageObjectCount | null, key: string) => {
  const onSale = objectsOnSale && objectsOnSale[key];

  return onSale ? `${onSale} ${plural(onSale, NEW_OBJECT_VARIANTS[key])}` : undefined;
};
